// extracted by mini-css-extract-plugin
export default {"linkCell":"InvoicePipedriveLinkCell_linkCell__Cg2GO","openButton":"InvoicePipedriveLinkCell_openButton__lTsmp","errorText":"InvoicePipedriveLinkCell_errorText__21aCT"};